import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import 'tippy.js/dist/tippy.css';
import reportWebVitals from './reportWebVitals';
import AppWrapper from './App';
import { AuthProvider } from './firebase/useAuth';
import { ForecastProvider } from './contexts/ForecastProvider';
import { MetadataProvider } from './contexts/MetadataProvider';
import { preloadAllImages } from './utils/imageManager';

// Cache all illustrations up front: no pop-in on navigation, and
// failure-state images stay available once the network breaks
preloadAllImages();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <MetadataProvider>
        <ForecastProvider>
          <AppWrapper />
        </ForecastProvider>
      </MetadataProvider>
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Register service worker for PWA functionality (production only)
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') { // eslint-disable-line no-undef
  // Register service worker after a small delay to not block initial page load
  setTimeout(() => {
    navigator.serviceWorker.register('/service-worker.js', {
      scope: '/'
    })
      .then((registration) => {
        console.log('[App] SW registered: ', registration);
        
        // Check if there's an existing service worker
        if (registration.active) {
          console.log('[App] Service worker is active');
        }
        
        // Track if this is the first install
        const hadActiveWorker = registration.active;
        
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          console.log('[App] New service worker found');
          
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              console.log('[App] New service worker state:', newWorker.state);
              if (newWorker.state === 'activated') {
                // Only reload if there was a previous active worker (this is an update)
                if (hadActiveWorker && navigator.serviceWorker.controller) {
                  console.log('[App] New service worker activated. Page will refresh in 1 second...');
                  setTimeout(() => {
                    window.location.reload();
                  }, 1000);
                } else {
                  console.log('[App] Service worker activated for the first time');
                }
              }
            });
          }
        });
        
        // Update service worker periodically (every hour)
        setInterval(() => {
          registration.update().catch(() => {
            // Ignore update errors
          });
        }, 24 * 60 * 60 * 1000); // Check for updates every 24 hours
        
      })
      .catch((registrationError) => {
        console.error('[App] SW registration failed: ', registrationError);
        // If service worker fails, ensure the app still works
        console.log('[App] App will continue without service worker');
      });
  }, 100); // Small delay to not block initial render
  
  // Handle service worker messages
  navigator.serviceWorker.addEventListener('message', (event) => {
    console.log('[App] Message from service worker:', event.data);
  });
  
  // Handle service worker controller changes
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    console.log('[App] Service worker controller changed');
  });
}
